import videoWebm from '../../../video/charles_cantin.webm'
import videoMp4 from '../../../video/charles_cantin.mp4'

import paths from '../../../config/paths'
import { useEffect } from 'react'

export default function CharlesCantin({ visited }) {

    useEffect(() => {
        visited();
    }, []);

    return(
        <main className="relative flex flex-col justify-evenly">
            <div className='video'>
                <video controls width="100%" height="100%" preload="true">
                    <source src={videoWebm} type="video/webm" />
                    <source src={videoMp4} type="video/mp4" />
                    <p>Votre navigateur ne prend pas en charge la vidéo.</p>
                </video>
            </div>
            <h2 className='title'>Charles Cantin</h2>
            <p className='content'>Evaluation demandant d'utiliser un CMS Headless (ici le CMS de Netlify) permettant la modification du site.</p>
            <p className='skills'>HTML/CSS | Javascript | React</p>
            <div className='project-button'>
                <a className='website' target="_blank" href="https://charles-cantin-photography.netlify.app/">Le site</a>
                <a className='github' target="_blank" href="https://github.com/Coussecousse/charles-cantin"><i className="fa-brands fa-github"></i>Github</a>
            </div>
            <div className='project-button big-buttons'>
                <a href={paths.QUAI_ANTIQUE} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Précédent projet</a>
                <a href={paths.PROJECTS} className='backProject'><i className="fa-solid fa-arrow-left mr-2"></i>Revenir aux projets</a>
                <a href={paths.DES_AVENTURES} className='backProject'>Prochain projet<i className="fa-solid fa-arrow-right ml-2"></i></a>
            </div>
        </main>
    )
}